import $ from 'jquery';

class NavSteps {
    constructor($jqueryObject) {
        let $current = $jqueryObject.find('.current');
        $jqueryObject.animate({'scrollLeft': $current.position().left}, 500);
    }
}

export default NavSteps;